import { Inject, Injectable } from '@angular/core';
import { GetByFilterToTableMethod } from 'eurogard-table-system';
import { RxapDataSource } from 'eurogard-data-source';
import { DynamicTableDataSource } from 'eurogard-data-source/table';
import {
  CompanyGuiControllerGetByAutocompleteRemoteMethod,
} from 'open-api-legacy/remote-methods/company-gui-controller-get-by-autocomplete.remote-method';

@Injectable()
@RxapDataSource('company-gui')
export class CompanyGuiTableDataSource extends DynamicTableDataSource {
  constructor(@Inject(CompanyGuiControllerGetByAutocompleteRemoteMethod) getByFilter: CompanyGuiControllerGetByAutocompleteRemoteMethod) {
    super(new GetByFilterToTableMethod(getByFilter));
  }
}
